/**
 * Videos
 */
(function ($) {
  $(document).on("ready", function () {
    if ($(".vidLink").length) {
      $(".vidLink").on("click", function (e) {
        e.preventDefault();
        var src = $(this).attr("data-src");
        if (src.includes("https://youtu.be/")) {
          src = src.replace("https://youtu.be/", "");
        }
        var iframe = '<iframe width="100%" src="https://www.youtube.com/embed/' + src + '?autoplay=1" frameborder="0" allowfullscreen></iframe>';
        addOverlay("video", iframe);
        $("#overlay iframe").height($("#overlay iframe").width() / (16 / 9));
      });
    }
  });
})(window.jQuery);
